import { h, Fragment, Component } from "preact";
import { useEffect, useState } from "react";

import { CustomFacet } from "./CustomFacet";
import { CustomSwatchFacet } from "./CustomSwatchFacet";
import { BuyBar } from "./BuyBar"; 

export const FacetState = () => {
  //Grab our data needed from window.Resources. Format as needed
  const learnMoreText = window.Resources.learnMoreText;
  const swatches_list = JSON.parse(window.Resources.swatches.textContent); // console.log(swatches_list.black.hexValue);
  const initialFilterObject = window.Resources.initialFilterObject;
  const initialFilterArrayofObjects = Object.values(initialFilterObject);

  const preSelectedOption = window.Resources.preSelectedOption;
  let preSelectedOptionArrayofObjects = [];
  if(preSelectedOption != false) {
    preSelectedOptionArrayofObjects = Object.keys(preSelectedOption);
  }

  const filterOrder = window.Resources.filterOrder;
  let parentFilterOrder = new Object();
  let childFilterOrder = new Object();

  if(filterOrder != false) {
    parentFilterOrder = Object.keys(filterOrder);
    childFilterOrder = Object.values(filterOrder);
  }

  //Initialize all useStates
  const [facets, setFacets] = useState([]);
  const [lowestPrice, setlowestPrice] = useState(0);
  const [listOfFacets, setListOfFacets] = useState([]);
  const [totalResults, setTotalResults] = useState(null);
  const [childProduct, setChildProduct] = useState(null);
  const [facetSelected, setFacetSelected] = useState(initialFilterArrayofObjects);
  const [childProductPrice, setChildProductPrice] = useState(0);

  useEffect(() => {
    let apiCall = "";
    let filters = "";

    const searchspringIo = "https://sg9vvc.a.searchspring.io/api/search/search.json?siteId=sg9vvc"; // Actual iPower SS data
    const resultsFormat = "&resultsFormat=native";
    let duplicateCheck = [];

    //Loop over useState array of selected filters. Build out API call
    //Concat them into a string for .fetch()
    facetSelected.map((value) => {
      if(!duplicateCheck.includes(value.filterValue)) {
        filters += `&filter.${value.filterField}=` + `${value.filterValue}`;
      }

      //Add each value to a duplicate check array
      //This prevents duplicate values to be added to the long API call string and cause a 502
      duplicateCheck.push(value.filterValue);
    });

    //Concat API call string
    apiCall = searchspringIo + filters + resultsFormat;

    //Money formatter
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
   
    //Searchspring API request
    fetch(apiCall).then((response) => 
      response.json()
    )
    .then((data) => {
      //Format response data so its easier to loop over
      let result = Object.entries(data);

      result.map((result) => {

        if(result[0] == "pagination") {
          //Set total results number. Controls buy bar logic - if equal to 1 display Continue button
          setTotalResults(result[1].totalResults);
        }

        if(result[0] == "facets") {
          setFacets(result[1]);
        }

        if(result[0] == "results") {
          //Find lowest price to display "From" price value in Buy Bar
          const lowPriceArray = [];

          //Push all prices into an array for comparison
          result[1].map((result) => {
            lowPriceArray.push(result.price);
          });

          //Compare and find the lowest price
          const lowestPriceFromArray = Math.min(...lowPriceArray);
          setlowestPrice(formatter.format(lowestPriceFromArray));

          //Full Price to be displayed once we filter down to 1 product
          let price = 0;

          if(result[1][0] !== undefined) {
            price = parseFloat(result[1][0].price);
          }

          const priceFormatted = formatter.format(price);

          //setState for child product object we are filtering down to. Only displayed if results == 1 in the return render() for buy bar
          setChildProduct(result[1][0]);
          setChildProductPrice(priceFormatted);
        }
      });
    });
  }, [facetSelected]);


  const firstLoadFunction = function() {
    //Same function as useEffect above, except this one only runs on the first page load
    //Check comments above for explantions.
    let apiCall = "";
    let filters = "";

    const searchspringIo = "https://sg9vvc.a.searchspring.io/api/search/search.json?siteId=sg9vvc"; // Actual iPower SS data
    const resultsFormat = "&resultsFormat=native";

    facetSelected.map((value) => {
      filters += `&filter.${value.filterField}=` + `${value.filterValue}`;
    });

    apiCall = searchspringIo + filters + resultsFormat;

    fetch(apiCall).then((response) => 
      response.json()
    )
    .then((data) => {
      let result = Object.entries(data);
      
      //Complex sort logic below
      let baseFilterArray = [];
      let secondStepFilteredArray = [];
      let fullyOrdered = [];

      result.map((result) => {
        if(result[0] == "facets") {

          //Push array of object Facets from API call into a temporary holding array for sorting 
          baseFilterArray.push(result[1]);
        }
      });

      //If filter order metafield is present
      if(filterOrder != false) {

        //Map through array of object Facets. Push them individually to a sorting array
        baseFilterArray.map((value) => {
          value.map((t)  => {
            secondStepFilteredArray.push(t);
          });
        });

        //First, filter out any facets with "hidden" in the name.
        secondStepFilteredArray = secondStepFilteredArray.filter(function(facet) {
          return !facet.label.includes("hidden");
        });

        //Secondly, filter out any facets that are in the Initial filter object
        //Don't want the customers to be able to see and change those
        secondStepFilteredArray.map((facet) => {
          if(initialFilterArrayofObjects.filter(e => e.filterField === facet.field).length <= 0) {

            //Push the filter results to a new clean array of objects
            fullyOrdered.push(facet);
          }
        });

        //Third, sort the "parent" facets based on the metafield values.
        fullyOrdered.sort((a, b) => parentFilterOrder.indexOf(a.field) - parentFilterOrder.indexOf(b.field));

        //Then, loop through a parent facet's Value object - Sort those "child" options based on metafield
        fullyOrdered.map((order, index) => {

          //Store current loop index
          let currentLoopValueObject =  Object.values(childFilterOrder[index]);
          fullyOrdered[index].values.sort((a, b) => currentLoopValueObject.indexOf(a.label) - currentLoopValueObject.indexOf(b.label));
        });

        //Set the state
        setListOfFacets(fullyOrdered);
      }
      //If no sort is present
      else {
        result.map((result) => {
          if(result[0] == "facets") {
  
            //Store default facets in ListOfFacets
            setListOfFacets(result[1]);
          }
        });
      }
    });
  }

  useEffect(() => {
    firstLoadFunction();
  }, []);

  return (
    <div className="facet-state">

      {/* If a sort is present */}
      {filterOrder != false &&
        <>
        {/* Loop through all Facets */}
        {/* Pre-filtered and sorting done above */}
        {listOfFacets.map((facet) => {
          return(
            <div className="facet-state__facets">

              {/* Logic for Swatches */}
              {facet.label == "Color/Finish" && 
                <> 
                  <p className="facet-state__facets__label text-body">{facet.label}: </p>
                  <div className="facet-state__facets__swatches-wrapper" data-ss-field={facet.field}>
                    {facet.label == "Color/Finish" && 
                      facet.values.map((values) => {
                        return(
                          <CustomSwatchFacet 
                            filter={facet}
                            values={values}
                            facets={facets}
                            facetSelected={facetSelected}
                            swatches_list={swatches_list}
                            setFacetSelected={setFacetSelected}
                            initialFilterArrayofObjects={initialFilterArrayofObjects}
                            preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                          />
                        )
                      })
                    }
                  </div>
                </>
              }

              {/* Logic for Cosmetic Condition (Learn More link) */}
              {facet.label == "Cosmetic Condition"
                &&
                <>
                  <p className="facet-state__facets__label text-body">{facet.label}
                    <a 
                      className="link facet-state__facets__label--learn-more"
                      >
                        {learnMoreText}
                    </a>
                  </p>
                  {facet.values.map((values, i) => {
                    return(
                      <CustomFacet 
                        filter={facet}
                        values={values}
                        facets={facets}
                        facetSelected={facetSelected}
                        setFacetSelected={setFacetSelected}
                        initialFilterArrayofObjects={initialFilterArrayofObjects}
                        preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                      />
                    )
                  })}
                </>
              }
              
              {/* Logic for all other filters */}
              {facet.label != "Color/Finish"
                && facet.label != "Cosmetic Condition"
                &&
                <>
                  <p className="facet-state__facets__label text-body">{facet.label}</p>
                  {facet.values.map((values, i) => {
                    return(
                      <CustomFacet 
                        filter={facet}
                        values={values}
                        facets={facets}
                        facetSelected={facetSelected}
                        setFacetSelected={setFacetSelected}
                        initialFilterArrayofObjects={initialFilterArrayofObjects}
                        preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                      />
                    )
                  })}
                </>
              }
            </div>
          )
        })}
        </>
      }

      {/* If a sort is not present */}
      {filterOrder == false &&
        <>
          {listOfFacets.map((facet) => {
            return(
              <div className="facet-state__facets">

                {facet.label == "Color/Finish" && 
                  <> 
                    <p className="facet-state__facets__label text-body">{facet.label}: </p>
                    <div className="facet-state__facets__swatches-wrapper" data-ss-field={facet.field}>
                      {facet.label == "Color/Finish" && 
                        facet.values.map((values) => {
                          return(
                            <CustomSwatchFacet 
                              filter={facet}
                              values={values}
                              facets={facets}
                              facetSelected={facetSelected}
                              swatches_list={swatches_list}
                              setFacetSelected={setFacetSelected}
                              initialFilterArrayofObjects={initialFilterArrayofObjects}
                              preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                            />
                          )
                        })
                      }
                    </div>
                  </>
                }

                {facet.label == "Cosmetic Condition"
                  &&
                  <>
                    <p className="facet-state__facets__label text-body">{facet.label}
                      <a 
                        className="link facet-state__facets__label--learn-more"
                        >
                          {learnMoreText}
                      </a>
                    </p>
                    {facet.values.map((values, i) => {
                      return(
                        <CustomFacet 
                          filter={facet}
                          values={values}
                          facets={facets}
                          facetSelected={facetSelected}
                          setFacetSelected={setFacetSelected}
                          initialFilterArrayofObjects={initialFilterArrayofObjects}
                          preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                        />
                      )
                    })}
                  </>
                }
                
                {facet.label != "Color/Finish"
                  && facet.label != "Cosmetic Condition"
                  && !facet.label.includes("hidden")
                  && initialFilterArrayofObjects.filter(e => e.filterField === facet.field).length <= 0
                  &&
                  <>
                    <p className="facet-state__facets__label text-body">{facet.label}</p>
                    {facet.values.map((values, i) => {
                      return(
                        <CustomFacet 
                          filter={facet}
                          values={values}
                          facets={facets}
                          facetSelected={facetSelected}
                          setFacetSelected={setFacetSelected}
                          initialFilterArrayofObjects={initialFilterArrayofObjects}
                          preSelectedOptionArrayofObjects={preSelectedOptionArrayofObjects}
                          // onClick={() => {console.log("Test Click ", facets);}}
                        />
                      )
                    })}
                  </>
                }
              </div>
            )
          })}
        </>
      }
      
      <BuyBar 
        lowestPrice={lowestPrice}
        totalResults={totalResults}
        childProduct={childProduct}
        childProductPrice={childProductPrice}
      /> 
    </div>
  )
}